import dayjs from 'dayjs'
import dayOfYear from 'dayjs/plugin/dayOfYear'
import { useMemo } from 'react'

dayjs.extend(dayOfYear)

const today = new Date()
const dayOfWeek = today.getDay()
const dayOfTheYear = dayjs(today).dayOfYear()
let weekStarts = dayOfTheYear - dayOfWeek
let weekEnds = dayOfTheYear - dayOfWeek + 7
if (weekStarts < 0) weekStarts = 0
if (weekEnds > 365) weekEnds = 365

export const YEAR = dayjs().year()

export const daysOfWeek = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday'
]

export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
]

const getNumberOfDaysInMonth = (year, month) => {
  return dayjs(`${year}-${month}-01`).daysInMonth()
}

export const createDaysForPreviousMonth = (year, month, currentMonthDays) => {
  const firstDayOfTheMonthWeekday = getWeekday(currentMonthDays[0].dateString)
  const previousMonth = dayjs(`${year}-${month}-01`).subtract(1, 'month')

  const visibleNumberOfDaysFromPreviousMonth =
    firstDayOfTheMonthWeekday - 1 < 0 ? 0 : firstDayOfTheMonthWeekday - 1

  const previousMonthLastMondayDayOfMonth = dayjs(
    currentMonthDays[0].dateString
  )
    .subtract(visibleNumberOfDaysFromPreviousMonth, 'day')
    .date()

  return [...Array(visibleNumberOfDaysFromPreviousMonth)].map((_, index) => {
    return {
      dateString: dayjs(
        `${previousMonth.year()}-${previousMonth.month() +
          1}-${previousMonthLastMondayDayOfMonth + index}`
      ).format('YYYY-MM-DD'),
      dayOfMonth: previousMonthLastMondayDayOfMonth + index,
      isCurrentMonth: false,
      isPreviousMonth: true
    }
  })
}

const createDaysForCurrentMonth = (year, month) => {
  return [...Array(getNumberOfDaysInMonth(year, month))].map((_, index) => {
    const dayJS = dayjs(`${year}-${month}-${index + 1}`)
    const dayOfTheYear = dayJS.dayOfYear()
    return {
      dateString: dayJS.format('YYYY-MM-DD'),
      dayOfTheYear,
      dayOfMonth: index + 1,
      isCurrentMonth: true,
      isNextMonth: false,
      isPreviousMonth: false,
      currentWeek: dayOfTheYear > weekStarts && dayOfTheYear <= weekEnds
    }
  })
}

const createDaysForNextMonth = (year, month, currentMonthDays) => {
  const lastDayOfTheMonthWeekday = getWeekday(
    `${year}-${month}-${currentMonthDays.length}`
  )
  const nextMonth = dayjs(`${year}-${month}-01`).add(1, 'month')
  const visibleNumberOfDaysFromNextMonth = 6 - lastDayOfTheMonthWeekday

  return [...Array(visibleNumberOfDaysFromNextMonth)].map((day, index) => {
    return {
      dateString: dayjs(
        `${nextMonth.year()}-${nextMonth.month() + 1}-${index + 1}`
      ).format('YYYY-MM-DD'),
      dayOfMonth: index + 1,
      isCurrentMonth: false,
      isNextMonth: true
    }
  })
}

export const getWeekday = dateString => {
  return dayjs(dateString).day()
}

export const useCalendarData = () => {
  return useMemo(() => {
    return months.map((_, index) => {
      const monthIndex = index + 1

      let currentMonthDays = createDaysForCurrentMonth(YEAR, monthIndex)

      let previousMonthDays = createDaysForPreviousMonth(
        YEAR,
        monthIndex,
        currentMonthDays
      )

      let nextMonthDays = createDaysForNextMonth(
        YEAR,
        monthIndex,
        currentMonthDays
      )
      return {
        title: months[index],
        days: [...previousMonthDays, ...currentMonthDays, ...nextMonthDays]
      }
    })
  }, [])
}
